import React, { useContext, useEffect, useState } from "react";
import { Row,Col,Container,Spinner,Badge} from 'react-bootstrap';
import {chains,eyeglasses,hats,leftHands,rightHands,getGeneration} from './metadata';

const GetNFT=(props)=>{
    const [loading,setLoading] = useState(true);//Loading bar
    const [generation,setGeneration]=useState("");

    const [chain,setChain]=useState("");
    const [eyeglass,setEyeglass]=useState("");
    const [hat,setHat]=useState("");
    const [lefthand,setLefthand]=useState("");
    const [righthand,setRighthand]=useState("");
    const [bgColor,setBgColor]=useState("");

    const setImageData=(name)=>{
        var hatId=parseInt(name.slice(6,7));
        var eyeglassId=parseInt(name.slice(7,8));
        var chainId=parseInt(name.slice(8,9));
        var lefthandId=parseInt(name.slice(9,11));
        var righthandId=parseInt(name.slice(11,13));
        
        //Set Images
        if(chains[chainId]!==undefined)
            setChain(chains[chainId]);
        if(eyeglasses[eyeglassId]!==undefined)
            setEyeglass(eyeglasses[eyeglassId]);
        if(hats[hatId]!==undefined)
            setHat(hats[hatId]);
        if(leftHands[lefthandId]!==undefined)
            setLefthand(leftHands[lefthandId]);
        if(rightHands[righthandId]!==undefined)
            setRighthand(rightHands[righthandId]);
            
        //Background Color
        var bg = name.charAt(name.length - 1);
        switch(bg){
            case 'R': setBgColor("#e74f4f");
                    break;
            case 'G': setBgColor("#4CBD55");
                    break;
            case 'B': setBgColor("#4F77E7");
                    break;
            case 'Y': setBgColor("#E7CD4F");
                    break;
            default: setBgColor("#fff");
        }

        /*********** 
        if(chains[chainId]==undefined)
            console.log(chains[chainId]);
        if(eyeglasses[eyeglassId]==undefined)
            console.log("eyeglass is "+eyeglasses);
        if(hats[hatId]==undefined)
            console.log(hats[hatId]);
        if(leftHands[lefthandId]==undefined)
            console.log(leftHands[lefthandId]);
        if(rightHands[righthandId]==undefined)
            console.log(rightHands[righthandId]);
        **********/
        
        //Set Generation Name
        setGeneration(getGeneration(chainId, eyeglassId, hatId, lefthandId, righthandId));
        setLoading(false);
    }

    useEffect(()=>{
        if(props.nftName){
            setImageData(props.nftName);
        }
    });

    return(
        <div className={loading ? 'parentDisable' : ''} width="100%">
            <div className={loading ? 'overlay-box' : 'hide'}>
                <Spinner animation="border" role="status">
                    <span className="visually-hidden">Loading...</span>
                </Spinner>
            </div>
            <div className="nft-div-view">
                <div className='layers' style={{backgroundColor:bgColor}}>
                    <Badge bg="secondary" style={{margin:'3%'}}>{generation}</Badge>
                    <img id="chracter" src={require("../nftdata/Character/panda.png")} />
                    {chain.length<2?"":<img id="chain" src={require("../nftdata/Chain/"+chain+".png")} hidden={chain.length<2}/>}
                    {eyeglass.length<2?"":<img id="eyeglass" src={require("../nftdata/Eyeglass/"+eyeglass+".png")} hidden={eyeglass.length<2}/>}
                    {hat.length<2?"":<img id="hat" src={require("../nftdata/Hat/"+hat+".png")} hidden={hat.length<2}/>}
                    {lefthand.length<2?"":<img id="left-hand" src={require("../nftdata/Left hand/"+lefthand+".png")} hidden={lefthand.length<2}/>}
                    {righthand.length<2?"":<img id="right-hand" src={require("../nftdata/Right hand/"+righthand+".png")} hidden={righthand.length<2}/>}
                </div>
            </div>
    </div>
    )
}

export default GetNFT